import React from 'react';

import { TemplateSystemName } from '../../../../apis/graphql/types';
import { Notification } from '../../../../components/BlueTheme';
import { NotificationType } from '../../../../components/BlueTheme/Notification/types';
import { TopBottomIndentsWrapper } from '../../../../components/BlueTheme/Wrappers/styled';
import { default as StandardDeliveryView } from '../StandardDelivery/View/View';
import { default as StandardDeliveryDHCView } from '../StandardDeliveryDHC/View/View';

type Props = {
  reportTemplateSystemName: TemplateSystemName;
  templateName: string;
};

const View = ({ reportTemplateSystemName, templateName }: Props): JSX.Element => {
  switch (reportTemplateSystemName) {
    case TemplateSystemName.DPlusStandardDelivery:
      return <StandardDeliveryView is3PDelivery={false} templateName={templateName} />;
    case TemplateSystemName.DPlusStandardDelivery_3P:
      return <StandardDeliveryView is3PDelivery templateName={templateName} />;
    case TemplateSystemName.DPlusDevice:
      return <StandardDeliveryDHCView templateName={templateName} />;
    default:
      return (
        <TopBottomIndentsWrapper>
          <Notification
            type={NotificationType.error}
            description={`Cannot get Report Data. The service does not support ${reportTemplateSystemName} report type.`}
          />
        </TopBottomIndentsWrapper>
      );
  }
};

export default View;
